// Tenký wrapper nad fetch. Cookie je HttpOnly, takže `credentials: 'include'` je klíčové.

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public detail?: unknown) {
    super(message);
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
    },
    ...init,
  });

  const text = await res.text();
  const data = text ? (JSON.parse(text) as Record<string, unknown>) : {};

  if (!res.ok) {
    const code = typeof data.error === 'string' ? data.error : `HTTP_${res.status}`;
    const message = typeof data.message === 'string' ? data.message : res.statusText;
    throw new ApiError(res.status, code, message, data);
  }

  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(body ?? {}) }),
  put: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PATCH', body: JSON.stringify(body ?? {}) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
  form: async <T>(path: string, form: FormData, method: 'POST' | 'PATCH' = 'POST'): Promise<T> => {
    const res = await fetch(`/api${path}`, { method, credentials: 'include', body: form });
    const text = await res.text();
    const data = text ? JSON.parse(text) : {};
    if (!res.ok) {
      const code = typeof data.error === 'string' ? data.error : `HTTP_${res.status}`;
      throw new ApiError(res.status, code, code, data);
    }
    return data as T;
  },
};
